import React from 'react';
import { ForgeIcon, ForgeIconButton, ForgeTooltip } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';

interface ExpandCollapseButtonsProps {
  level?: number;
  expandDisabled?: boolean;
  onNodeLevelChange?: (level?: number) => void;
}

export const ExpandCollapseButtons = (props: ExpandCollapseButtonsProps) => {
  const { level, onNodeLevelChange, expandDisabled } = props;

  const onExpand = () => onNodeLevelChange?.((level ?? 0) + 1);
  const onCollapseAll = () => onNodeLevelChange?.(undefined);
  const collapseDisabled = !level;

  const expandButtonText = I18n.t('shared.visualizations.charts.common.toolbar_options.expand_groups');
  const collapseButtonText = I18n.t(
    'shared.visualizations.charts.common.toolbar_options.collapse_all_groups',
  );

  const handleEnterKey = (onClick: () => void, e: React.KeyboardEvent) => {
    if (e.keyCode === 13) {
      // keyCode 13 is "Enter"
      onClick();
    }
  };

  return (
    <>
      <ForgeIconButton
        disabled={collapseDisabled}
        onKeyDown={handleEnterKey.bind(this, onCollapseAll)}
        data-testid="expand-collapse-bar-collapse-btn"
        aria-label={collapseButtonText}
        className="tyler-icons"
        onClick={onCollapseAll}
      >
        <ForgeIcon name="chevron_double_up" />
        <ForgeTooltip placement="bottom">{collapseButtonText}</ForgeTooltip>
      </ForgeIconButton>
      <ForgeIconButton
        disabled={expandDisabled}
        onKeyDown={handleEnterKey.bind(this, onExpand)}
        data-testid="expand-collapse-expand-collapse-btn"
        aria-label={expandButtonText}
        className="tyler-icons"
        onClick={onExpand}
      >
        <ForgeIcon name="chevron_double_down" />
        <ForgeTooltip placement="bottom">{expandButtonText}</ForgeTooltip>
      </ForgeIconButton>
    </>
  );
};

export default ExpandCollapseButtons;
